import React from 'react'

import { makeStyles } from '@mui/styles'
import Notification from '@/modules/base/components/notification/overlay/notification'
import { INotification } from '@/modules/base/components/notification/notificationService'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  seperator: {
    borderBottom: `1px solid ${theme.mode.borderColor.light}`,
    margin: '0px 30px',
  },
}
))

interface INotificationList {
  notifications: INotification[],
  dateFormat: string,
}

const NotificationList = ({ notifications, dateFormat = 'DD.MM.YYYY, HH:mm' }: INotificationList) => {
  const classes = useStyles()

  const notificationEls = notifications.map((notification, index) => {
    return (
      <div className={classes.wrapper}>
        <Notification key={`${notification.id}_${notification.readDate}`} dateFormat={dateFormat} {...notification} />
        {(notifications.length - 1) !== index && <div className={classes.seperator} />}
      </div>
    )
  })

  return (<>{notificationEls}</>)
}

export default NotificationList
